import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {CSSProperties} from 'react';

import {CheckMarkIcon} from '@src/components/icons';

interface WrapperProps {
  backgroundColor: CSSProperties['color'];
  isBoxShadow: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  ${({theme, backgroundColor, isBoxShadow}) => css`
    background-color: ${backgroundColor || theme.colors.lightBg};
    border-radius: 16px;
    height: fit-content;
    min-width: 305px;
    padding: 26px 30px 28px 24px;
    width: 100%;

    ${isBoxShadow &&
    css`
      box-shadow: -8px 8px 18px rgba(0, 0, 0, 0.06);
    `}
  `}
`;

export const Title = styled.h3`
  ${({theme}) => css`
    color: ${theme.colors.gray7};
    margin-bottom: 24px;
    font-size: ${theme.font.sizes.small};
  `}
`;

export const Text = styled.p`
  ${({theme}) => css`
    color: ${theme.colors.gray7};
    font-size: ${theme.font.sizes.xsmall};
    line-height: 14px;
  `}
`;

export const List = styled.ul`
  margin-top: 20px;
  padding-left: 24px;
`;

interface ListItemProps {
  isValid: boolean;
}

export const ListItem = styled.li<ListItemProps>`
  ${({isValid}) => css`
    list-style: ${isValid ? 'none' : 'disc'};
    position: relative;
  `}
`;

export const GreenCheckMarkIcon = styled(CheckMarkIcon)`
  position: absolute;
  left: -17px;
  bottom: 5px;
  width: 9.2px;
`;
